export default "/images/8ae3192856fe383ecec5a7e7a36d800e.avif";